<script setup>
import { Codemirror } from 'vue-codemirror';
import { ref } from "vue";
import { css } from "@codemirror/lang-css";
import { dracula } from "@uiw/codemirror-theme-dracula";

Codemirror.compatConfig = { MODE: 3 };

const model = defineModel();
const props = defineProps({
    autofocus: Boolean,
    mode: {
        type: String,
        required: true,
        validator: value => ['javascript', 'css', 'html'].includes(value),
    }
});
const options = ref({ mode: `text/${props.mode}` });
const extensions = [ css(), dracula ];

function handleInput(code) {
    // Emit the input event to the parent component
    model.value = code
}
</script>

<template>
    <codemirror
        v-model="model"
        :style="{ height: '480px' }"
        :options="{mode: `text/${props.mode}`}"
        :autofocus="autofocus"
        :extensions="extensions"
    />
</template>
